import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { I18N } from '../../constants';

export const handleGenericValidations = (form, selectedManifestIds,selectedRoute, selectedReason, isReasonToShow) => {
    const errors = {};

    if (!moment(form.abnormalityDate).isValid()) {
        errors.abnormalityDate = 'You must provide a valid date.';
    }

    if (isEmpty(form.abnormalityType)) {
        errors.abnormalityType = 'You must choose a type.';
    }

    if (isEmpty(form.abnormalityLocation)) {
        errors.abnormalityLocation = 'You must choose a location.';
    }

    if (selectedManifestIds && selectedManifestIds.length === 0) {
        errors.selectedManifests = 'You must choose at least one manifest.';
    }

    if (isEmpty(selectedRoute)) {
            errors.routeCode = 'You must choose a run.';
    }
	
	if (selectedReason === I18N.FORMS.SELECT_REASON && isReasonToShow) {
        errors.reason = 'You must select a reason.';
    }

    return errors;
};
